// The one sentence that says why a document is read only — the banner's
// text, and the toast when an open editor loses editing.

import { apiErrorMessage } from './apiError.js';
import { lockOf } from './nodeAccess.js';

export function fileStateText(t, reason, lock, { mine = false } = {}) {
  if (reason === 'locked') {
    const name = lock?.byName || t('editor:block.someone');
    if (mine) return lock?.reason ? t('editor:block.lockedByYou', { reason: lock.reason }) : t('editor:block.lockedByYouNoReason');
    return lock?.reason ? t('editor:block.locked', { name, reason: lock.reason }) : t('editor:block.lockedNoReason', { name });
  }
  if (!reason) return '';
  return t(`editor:block.${reason}`);
}

/** Error text for a refused lock/unlock — names who holds the file when it is someone else. */
export function lockErrorMessage(t, errorInfo) {
  return apiErrorMessage(errorInfo, {
    file_locked: (parsed) => {
      const lock = lockOf({ lock: parsed.params?.lock });
      return lock ? fileStateText(t, 'locked', lock) : t('errors:file_locked');
    },
  });
}
